import "./about.css"
import about_us from "../../../assets/about-us.webp";
import React from "react";
import {useTranslation} from "react-i18next";

function AboutUs() {

    const {t} = useTranslation()

    return (
        <div className="flex lg:flex-row flex-column">
            <div className="left_side">
                <img style={{width: "100%"}} src={about_us} alt=""/>
            </div>
            <div className="right_side">
                <h1 className="about_heading text-center font-normal mt-3 text-6xl">{t('about.about_us')}</h1>

                <p className="font-normal text-base">{t('about.about_us1')}</p>

                <p className="font-normal text-base">{t('about.about_us2')}</p>

                <p className="font-normal text-base">{t('about.about_us3')}</p>

                <p className="font-normal text-base">{t('about.about_us4')}</p>
            </div>
        </div>
    )
}

export default AboutUs